import { QueryClient, QueryClientConfig } from '@tanstack/react-query';
import { cache } from 'react';

import { FIVE_MINUTES } from './constants/time';

export const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: FIVE_MINUTES,
      retry: false,
      retryOnMount: false,
    },
  },
};

export const getQueryClient = cache(() => new QueryClient(queryClientConfig));
